/* Cherry Twist — age verification.
   Two gates: a site-entry affirmation, and a required confirmation at checkout.
   Self-contained. Delete this file and its <script> tag in layout/theme.liquid to remove. */
(function () {
  var KEY = 'ct_age_ok', DAYS = 30;

  function verified() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      return v && (Date.now() - v.t) < DAYS * 864e5;
    } catch (e) { return false; }
  }
  function remember() {
    try { localStorage.setItem(KEY, JSON.stringify({ ok: true, t: Date.now() })); } catch (e) {}
  }

  /* ---------- 1 · site entry gate ---------- */
  function gate() {
    if (verified()) return;
    var w = document.createElement('div');
    w.className = 'ct-age';
    w.setAttribute('role', 'dialog');
    w.setAttribute('aria-modal', 'true');
    w.setAttribute('aria-labelledby', 'ct-age-h');
    w.innerHTML =
      '<div class="ct-age__box">' +
        '<svg class="ct-age__mark" viewBox="0 0 48 48" aria-hidden="true">' +
          '<path d="M24 13C18 20 15 25 16 31" stroke="#161013" stroke-width="3" fill="none" stroke-linecap="round"/>' +
          '<path d="M24 13C30 20 33 25 34 31" stroke="#161013" stroke-width="3" fill="none" stroke-linecap="round"/>' +
          '<path d="M24 13C29 7 36 7 40 11C34 14 28 14 24 13Z" fill="#C8F65C" stroke="#161013" stroke-width="2" stroke-linejoin="round"/>' +
          '<circle cx="15" cy="35" r="9.5" fill="#F50537" stroke="#161013" stroke-width="3"/>' +
          '<circle cx="34" cy="35" r="9" fill="#FF5C8A" stroke="#161013" stroke-width="3"/></svg>' +
        '<p class="ct-age__brand">Cherry Twist</p>' +
        '<h2 class="ct-age__h" id="ct-age-h">Are you 18 or over?</h2>' +
        '<p class="ct-age__p">We sell alcohol, so we have to ask. You must be 18 or over to buy from this site.</p>' +
        '<div class="ct-age__btns">' +
          '<button type="button" class="ct-age__yes">Yes, I am 18 or over</button>' +
          '<button type="button" class="ct-age__no">No, I am under 18</button>' +
        '</div>' +
        '<p class="ct-age__small">Please drink responsibly. <a href="https://www.drinkaware.co.uk" rel="noopener" target="_blank">drinkaware.co.uk</a></p>' +
      '</div>';
    document.body.appendChild(w);
    document.documentElement.setAttribute('scroll-lock', '');

    var yes = w.querySelector('.ct-age__yes'), no = w.querySelector('.ct-age__no');
    yes.focus();

    yes.addEventListener('click', function () {
      remember();
      document.documentElement.removeAttribute('scroll-lock');
      w.remove();
    });
    no.addEventListener('click', function () {
      w.querySelector('.ct-age__box').innerHTML =
        '<h2 class="ct-age__h">Sorry — come back when you are 18.</h2>' +
        '<p class="ct-age__p">You have to be 18 or over to buy alcohol in the UK, so we cannot let you in just yet.</p>' +
        '<p class="ct-age__small"><a href="https://www.drinkaware.co.uk" rel="noopener" target="_blank">drinkaware.co.uk</a></p>';
    });
    /* keep focus inside the dialog */
    w.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = w.querySelectorAll('button, a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- 2 · checkout confirmation ---------- */
  function cartGate() {
    var btn = document.getElementById('checkout');
    if (!btn || document.querySelector('.ct-agecheck')) return;

    var wrap = document.createElement('label');
    wrap.className = 'ct-agecheck';
    wrap.innerHTML =
      '<input type="checkbox" class="ct-agecheck__box">' +
      '<span>I confirm I am <strong>18 or over</strong>. ID may be requested on delivery.</span>';
    btn.parentNode.insertBefore(wrap, btn);

    var box = wrap.querySelector('input');
    var extra = document.querySelectorAll('.additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"]');

    function sync() {
      var ok = box.checked;
      btn.disabled = !ok;
      btn.setAttribute('aria-disabled', String(!ok));
      extra.forEach(function (el) {
        el.style.pointerEvents = ok ? '' : 'none';
        el.style.opacity = ok ? '' : '0.45';
      });
      if (ok) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Age confirmed': 'Yes — 18 or over' } })
        }).catch(function () {});
      }
    }
    box.addEventListener('change', sync);
    sync();
  }

  function init() { gate(); cartGate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Horizon swaps the cart section in without a page load */
  document.addEventListener('shopify:section:load', cartGate);
  document.addEventListener('cart:update', cartGate);
  new MutationObserver(function () { cartGate(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
